export function startSearch(coins, coinsListWithNames, searchText, favs = []) {
	let newList = [];
	let newFavs = [];
	const currList = coins.slice(0);
	const currFavs = favs.slice(0);
	const trimmedSearchText = searchText
		.toLowerCase()
		.trim()
		.replace(/\s/g, '');

	if (trimmedSearchText !== '') {
		// const currCoins = currList.map(coin => `${coin}${coinParams[coin].coinName}`);
		let newExp = ''; //`(?=${searchText})`;
		trimmedSearchText
			.split('')
			.forEach(char => (newExp = `${newExp}(?=.*${char})`));

		const newSearch = new RegExp(`${newExp}`);

		if (currFavs.length > 0) {
			newFavs = currFavs.filter(coinItem => {
				const coin = coinItem.split('-')[0].toLowerCase();
				const coinSym = coin === 'ven' ? 'vet' : coin;
				const coinName = coinsListWithNames.hasOwnProperty(coin)
					? coinsListWithNames[coin].toLowerCase()
					: '';

				return `${coinSym}${coinName}`.search(newSearch) > -1;
			});
		}

		newList = currList.filter(coinItem => {
			const coin = coinItem.split('-')[0].toLowerCase();
			const coinSym = coin === 'ven' ? 'vet' : coin;
			const coinName = coinsListWithNames.hasOwnProperty(coin)
				? coinsListWithNames[coin].toLowerCase()
				: '';

			return (
				`${coinSym}${coinName}`.search(newSearch) > -1 &&
				newFavs.indexOf(coinItem) < 0
			);
		});
	} else {
		newFavs = currFavs;
		newList = currList.filter(coin => currFavs.indexOf(coin) < 0);
	}

	const nLNearest = [];
	const nLFarthest = [];
	const nFNearest = [];
	const nFFarthest = [];

	for (let i = 0; i < newList.length; i++) {
		const coinItem = newList[i];
		const coin = coinItem.split('-')[0].toLowerCase();
		const coinName = coinsListWithNames.hasOwnProperty(coin)
			? coinsListWithNames[coin].toLowerCase()
			: '';
		if (
			coinName.startsWith(trimmedSearchText) ||
			coin.startsWith(trimmedSearchText)
		) {
			nLNearest.push(coinItem);
		} else {
			nLFarthest.push(coinItem);
		}
	}

	for (let i = 0; i < newFavs.length; i++) {
		const coinItem = newFavs[i];
		const coin = coinItem.split('-')[0].toLowerCase();
		const coinName = coinsListWithNames.hasOwnProperty(coin)
			? coinsListWithNames[coin].toLowerCase()
			: '';
		if (
			coinName.startsWith(trimmedSearchText) ||
			coin.startsWith(trimmedSearchText)
		) {
			nFNearest.push(coinItem);
		} else {
			nFFarthest.push(coinItem);
		}
	}

	return {
		newList: [...nLNearest, ...nLFarthest],
		newFavs: [...nFNearest, ...nFFarthest],
	};
}
